/**
 * In-memory quiz progress for Q1–7 (Pathfinder steps are out of band in the iframe).
 * Extracted for clarity; the UI controller owns lifecycle and mutations.
 */
export type AnswerSelection = number | null;

/** Seven slots aligned with Q1–7; each holds selected answer index or `null` until chosen. */
export function createInitialSelections(): AnswerSelection[] {
  return Array.from({ length: 7 }, () => null);
}
